import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ReservationsContainer } from '@ruby/modules/reservations/container/reservations.container';

const routes: Routes = [
  { path: ':status', component: ReservationsContainer, pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReservationsRoutingModule {}
